// teams

import http from '../../../store/api/http' 

const actions = {
    getTeams(context, param) {
    	console.log('action->getTeams')
    	let query = '?page=' + param.page
    	query += '&sortby=' + (param.sortBy ? param.sortBy : '')
    	query += '&sortdir=' + (param.sortDesc ? param.sortDesc : 'asc')
    	query += '&filter=' + param.filter
    	query += '&paginate=yes'
		return new Promise((resolve, reject) => {
			http.get('/api/teams' + query)
			.then(function (response) {
		    	if(typeof(response.data) === 'object' && response.data.data instanceof Array) {
					context.commit('getTeams', response.data.data)
		    	} else reject(error)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    editTeam(context, data) {
    	console.log('action->editTeam')
		return new Promise((resolve, reject) => {
			http.get('/api/teams/' + data + '/edit')
			.then(function (response) {
		    	context.commit('getTeam', response.data)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    createTeam(context, data) {
    	console.log('action->createTeam')
		return new Promise((resolve, reject) => {
			http.post('/api/teams', data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    updateTeam(context, data) {
    	console.log('action->updateTeam')
		return new Promise((resolve, reject) => {
			http.patch('/api/teams/' + data.id, data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    storeTeam(context, data) {
    	console.log('action->storeTeam')
		return new Promise((resolve, reject) => {
			context.dispatch(data.id>0 ? 'updateTeam' : 'createTeam', data)
      		.then((response) => {
				resolve(response)
  			})
	    	.catch((error) => {
				reject(error)
		    });
		})
    },

};

export default actions;